var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalfollowups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3542 22.295C22.4872 22.295 17.7142 17.487 17.7142 11.576C17.7142 5.666 22.4872 0.856003 28.3542 0.856003C34.2212 0.856003 38.9942 5.666 38.9942 11.576C38.9942 17.487 34.2212 22.295 28.3542 22.295ZM28.3542 3.92C24.1652 3.92 20.7542 7.354 20.7542 11.576C20.7542 15.799 24.1652 19.233 28.3542 19.233C32.5442 19.233 35.9542 15.799 35.9542 11.576C35.9542 7.354 32.5442 3.92 28.3542 3.92ZM26.8342 5.45H29.8742V10.45H32.9152V13.107H26.8342V5.45ZM20.7532 30.718H14.6742V24.593H20.7532V30.718ZM11.6332 13.873H8.5932V4.686H11.6332V7.748H14.6742V10.811H11.6332V13.873ZM13.1532 23.61H7.73016V16.936H13.1532V23.61ZM13.1532 24.593V30.718H7.73016V24.593H13.1532ZM28.3542 24.593V30.718H22.2752V24.593H28.3542ZM4.34021 33.78H31.3932V23.61H34.4342V33.78C34.4342 35.473 33.7202 36.843 31.3932 36.843H4.34021C2.35421 36.843 0.993164 35.473 0.993164 33.78V10.811C0.993164 9.119 2.35421 7.748 4.34021 7.748H7.73016V10.811H4.34021V33.78Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalfollowups);
export default __webpack_public_path__ + "static/media/totalfollowups.9b4caa1f9bb1aad26cc3b47d6e0f318f.svg";
export { ForwardRef as ReactComponent };